/* global google, YT */
import "@fontsource/roboto";
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import '../css/common.css';
import '../css/menu-image.css';
import '../css/collection.css';
import '../css/single.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';

import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import adManager from './sidebar_ads.js';

import './login.js';
import './filters.js';
import './forms.js';

$(document).ready(function () {
    adManager.displayAds();
});

//Handle the responsive dropdown
var responsiveToggleButton = $('#brand-header .responsive-top-menu-toggle');
var responsiveDropDown = $('#brand-header .top-menu');

responsiveToggleButton.click(function (event) {
    // Here if we toggle, we could break the responsiveness if we enlarge the window
    if (responsiveDropDown.is(":visible")) {
        $(this).removeClass('active');
        responsiveDropDown.removeAttr('style');
    } else {
        $(this).addClass('active');
        responsiveDropDown.attr('style', 'display:block');
    }
});

//Copy sidebar widgets inside hidden place holder for a phone layout. The data-widget attibute follows the syntax of the nth child css selector
$('.inline-phone-sidebar-widget').each(function (idx, holder) {
    var widgetToCopy = $('#right-sidebar > ul > li:nth-child(' + $(holder).data('widget') + ')');
    $('<ul></ul').appendTo(holder).append(widgetToCopy.clone());
});

/*
 * function executed after google translate script is loaded
 */
window.googleTranslateElementInit = function() {
    new google.translate.TranslateElement({pageLanguage: 'en', includedLanguages: 'ar,bn,de,en,es,fa,fr,hi,ja,ko,ms,pa,pt,ru,zh-CN,zh-TW', autoDisplay: false, gaTrack: true, gaId: 'UA-8866786-4'}, 'google_translate_element');
};

// vimeo Autoplay
$('div.vimeo').click(function() {
    var iframe = $('div.vimeo iframe')[0];
    if(iframe) {
        iframe.contentWindow.postMessage('{ "method" : "play"}',"*");
    }
});

// youtube Autoplay
$('iframe.youtube-player').each(function(idx, value) {
    if (YT) {
        YT.ready(function() {
            var player = new YT.Player('youtube-player', {
                events: {
                    'onReady': function(event) {
                        $(player.getIframe()).parent().siblings('.actionable-overlay').click(function(event) {
                            if (!window.orientation) {
                                player.playVideo(); //On mobile devices youtube prevent the use of playVideo() https://developers.google.com/youtube/iframe_api_reference#Mobile_considerations
                            } else {
                                event.preventDefault();
                                event.stopPropagation();
                                event.stopImmediatePropagation();
                            }
                        });
                    }
                }
            });
        });
    }
});
